<template>
  <v-dialog max-width="450px" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title>
        <span class="headline">Info Config</span>
      </v-card-title>
      <v-card-text>
        <v-row dense class="mb-2">
          <v-col cols="12" sm="12" md="12">
            <v-checkbox v-model="model.rewardInfo" label="Reward Info" hide-details/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>Cancel</v-btn>
        <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {ItemInfoConfig} from "@/modules/redactor/models/item/info/ItemInfoConfig";

export default {
  name: "r-item-info-config",
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new ItemInfoConfig(),
    rules: ViewRules.READONLY,
    panels: []
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new ItemInfoConfig();
      this.panels = [];
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.empty()) {
        this.resolve(null);
        this.discard();
      } else if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    }
  }
}
</script>